import { Swiper } from 'swiper/vue';
export default Swiper;